module.exports = __webpack_public_path__ + "img/c02_unitcaravan_Normal_ua.ce10059f.webp";